/* NOURIYA — interactions page produit (v2) */
(function () {
  'use strict';

  /* Packs */
  var packs = document.querySelectorAll('.pack');
  var atcPrice = document.getElementById('atc-price');
  var atcBarPrice = document.getElementById('atcBarPrice');
  var atcBarNote = document.getElementById('atcBarNote');

  /* Offres réelles injectées par Liquid sur Shopify.
     Ordre imposé : [0] produit 1 tube · [1] Lot Duo · [2] Lot Trio.
     Une entrée vaut null tant que le lot n'existe pas dans le catalogue. */
  var VARIANTS = window.NOURIYA_VARIANTS || [];
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

  /* Lier chaque pack à son offre réelle */
  if (VARIANTS.length) {
    packs.forEach(function (pack, i) {
      var v = VARIANTS[i];
      if (!v || !v.id) return;   /* offre absente : on garde les prix en dur */
      pack.setAttribute('data-vid', v.id);
      pack.setAttribute('data-price', money(v.price));
      var pe = pack.querySelector('.pack__price b');
      if (pe) pe.textContent = money(v.price);
    });
    // aligner l'affichage du prix ATC sur le pack actif
    var act = document.querySelector('.pack.is-active');
    if (act) {
      if (atcPrice) atcPrice.textContent = act.getAttribute('data-price');
      if (atcBarPrice) atcBarPrice.textContent = act.getAttribute('data-price');
    }
  }

  packs.forEach(function (pack) {
    pack.addEventListener('click', function () {
      packs.forEach(function (p) { p.classList.remove('is-active'); });
      pack.classList.add('is-active');
      var price = pack.getAttribute('data-price');
      if (atcPrice) atcPrice.textContent = price;
      if (atcBarPrice) atcBarPrice.textContent = price;
      if (atcBarNote) atcBarNote.textContent = pack.getAttribute('data-note');
    });
  });

  /* Ajouter au panier (vrai panier Shopify) */
  function selectedVid() {
    /* Pas de repli sur la 1re offre : un lot manquant ne doit JAMAIS
       ajouter le tube seul au panier alors que le prix du lot est affiché. */
    var a = document.querySelector('.pack.is-active') || document.querySelector('.pack');
    return a && a.getAttribute('data-vid');
  }
  function addToCart(btn) {
    var vid = selectedVid();
    if (!vid) { // pas de produit relié (aperçu local) : ne rien casser
      alert('Aperçu : le panier sera actif une fois le produit publié.');
      return;
    }
    if (btn) { btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) { throw r; }
      return r.json();
    }).then(function () {
      window.location.href = '/cart';
    }).catch(function () {
      if (btn) { btn.disabled = false; }
      alert('Ce produit n’est pas encore disponible à la vente.');
    });
  }
  var atcBtn = document.getElementById('atc');
  if (atcBtn) { atcBtn.addEventListener('click', function () { addToCart(atcBtn); }); }
  var atcBarBtn = document.querySelector('#atcBar button');
  if (atcBarBtn) { atcBarBtn.addEventListener('click', function () { addToCart(atcBarBtn); }); }

  /* FAQ */
  document.querySelectorAll('.faq__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement, a = q.nextElementSibling;
      var open = item.classList.toggle('is-open');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
    });
  });

  /* Avant / Après — curseur */
  var range = document.getElementById('baRange');
  var after = document.getElementById('baAfter');
  var handle = document.getElementById('baHandle');
  function setBA(v) {
    if (after) after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
    if (handle) handle.style.left = v + '%';
  }
  if (range) { range.addEventListener('input', function () { setBA(range.value); }); setBA(range.value); }

  /* Barre ATC mobile */
  var atcBar = document.getElementById('atcBar');
  var buy = document.getElementById('soin');
  if (atcBar && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { atcBar.classList.toggle('is-visible', e.boundingClientRect.top < 0); });
    }, { threshold: 0 }).observe(buy);
  }

  /* Reveal + barres */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        e.target.querySelectorAll('.result__fill').forEach(function (b) { b.style.width = b.getAttribute('data-w'); });
        io.unobserve(e.target);
      });
    }, { threshold: 0.18 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
    document.querySelectorAll('.result__fill').forEach(function (b) { b.style.width = b.getAttribute('data-w'); });
  }

  /* Carrousels a fleches (avis + avant/apres) */
  function initCarousel(rowId, prevId, nextId, gap) {
    var row = document.getElementById(rowId), prev = document.getElementById(prevId), next = document.getElementById(nextId);
    if (!row || !prev || !next) return;
    var step = function () { var c = row.querySelector('figure, .review'); return c ? c.getBoundingClientRect().width + gap : 300; };
    var sync = function () {
      var max = row.scrollWidth - row.clientWidth - 2;
      prev.disabled = row.scrollLeft <= 2;
      next.disabled = row.scrollLeft >= max;
    };
    prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }
  initCarousel('reviews', 'revPrev', 'revNext', 22);
  initCarousel('baGallery', 'baPrev', 'baNext', 18);

  /* Menu burger mobile */
  var burger = document.getElementById('burger');
  var mmenu = document.getElementById('mobileMenu');
  if (burger && mmenu) {
    burger.addEventListener('click', function () {
      var open = mmenu.classList.toggle('is-open');
      burger.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    mmenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mmenu.classList.remove('is-open');
        burger.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }
})();
